import * as types from '../constants'

const initialState = {
  previousProduct: {},
  product: {},
  region: {},
  lpContent: {},
  manifestVideo: {},
  houseVivazContent: {},
  video: '',
  currentTour: {},
  currentGalleryModal: {},
}

const products = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_PRODUCT:
      return { ...state, product: action.payload }
    case types.UPDATE_LANDINGPAGE:
      return { ...state, lpContent: action.payload }
    case types.UPDATE_HIGHLIGHT_PRODUCT:
      return { ...state, highlight: action.payload }
    case types.UPDATE_CURRENT_GALLERY:
      return { ...state, currentGalleryModal: action.payload }
    case types.UPDATE_LOCATION_PRODUCT:
      return { ...state, location: action.payload }
    case types.UPDATE_RECREATION_PRODUCT:
      return { ...state, recreation: action.payload }
    case types.UPDATE_PLANT_PRODUCT:
      return { ...state, plant: action.payload }
    case types.UPDATE_FACILITIES_PRODUCT:
      return { ...state, facilities: action.payload }
    case types.UPDATE_MANIFEST_VIDEO:
      return { ...state, manifestVideo: action.payload }
    case types.UPDATE_HOUSE_VIVAZ:
      return { ...state, houseVivazContent: action.payload }
    case types.UPDATE_VIDEO_BY_ID_STATE:
      return { ...state, video: action.payload }
    case types.UPDATE_CUSTOM_LP:
      return { ...state, lpContent: action.payload }
    case types.UPDATE_PREVIOUS_PRODUCT:
      return { ...state, previousProduct: action.payload }
    case types.UPDATE_CURRENT_TOUR:
      return { ...state, currentTour: action.payload }
    default:
      return state
  }
}

export default products



// WEBPACK FOOTER //
// ./src/store/products/reducer.js